// Which look the game wears: the one-bit restyle (default) or the old colour version.
// A ?look= URL flag wins for that page load; otherwise the viewer's saved choice; otherwise the default.
export const LOOKS = ['one-bit', 'colour'];
export const DEFAULT_LOOK = 'one-bit';
export const LOOK_KEY = 'door.look';

const norm = v => {
  const s = String(v ?? '').toLowerCase().replace(/[\s_]/g, '-');
  if (s === 'onebit' || s === '1bit' || s === '1-bit' || s === 'night') return 'one-bit'; // the night door is the one-bit look in colour
  if (s === 'color' || s === 'classic') return 'colour';
  return LOOKS.includes(s) ? s : null;
};

export function resolveLook({ search = '', stored = null } = {}) {
  const flag = new URLSearchParams(search).get('look');
  return norm(flag) ?? norm(stored) ?? DEFAULT_LOOK;
}

export const otherLook = look => (look === 'colour' ? 'one-bit' : 'colour');
export const lookLabel = look => `Look: ${look}`;

// Sprint 33 item 3: inside the one-bit look the door wears level 2 night colour (client/night.js, owner decision 1), or stays
// pure ink and paper. A ?door= flag (or ?look=night / ?look=one-bit) wins for that page load, then the saved choice, then night.
export const DOORS = ['night', 'one-bit'];
export const DEFAULT_DOOR = 'night';
export const DOOR_KEY = 'door.colour';
const normDoor = v => {
  const s = String(v ?? '').toLowerCase().replace(/[\s_]/g, '-');
  if (s === 'night' || s === 'night-colour' || s === 'night-color' || s === 'l2') return 'night';
  if (s === 'one-bit' || s === 'onebit' || s === '1bit' || s === '1-bit') return 'one-bit';
  return null;
};
export function resolveDoor({ search = '', stored = null } = {}) {
  const q = new URLSearchParams(search);
  return normDoor(q.get('door')) ?? normDoor(q.get('look')) ?? normDoor(stored) ?? DEFAULT_DOOR;
}
// the Look setting's three stops, in the order one tap walks them: night colour, one bit, the old colour version
export const lookChoice = (look, door) => (look === 'colour' ? 'colour' : door === 'one-bit' ? 'one-bit' : 'night');
// The old colour version is a desktop layout (it clips at 390 px, sprint 33 QA bug 5), so a phone's walk skips it: night colour, one bit, back.
export const nextChoice = (c, phone = false) => ({ night: 'one-bit', 'one-bit': phone === true ? 'night' : 'colour', colour: 'night' })[c] ?? 'night';
export const choiceLabel = c => `Look: ${c === 'night' ? 'night colour' : c}`;
// what to save for a choice: { look, door }
export const choiceSaves = c => (c === 'colour' ? { look: 'colour', door: null } : { look: 'one-bit', door: c });

// The public game wears one look, night colour: the server marks the page and hides the Look button, and the page's
// first script then ignores any ?look= flag or saved choice. The studio server keeps the switch.
export const fixLook = html => html.replace('<html lang="en">', '<html lang="en" data-look-fixed>')
  .replace('<button class="look" id="look"', '<button class="look" id="look" hidden');

// Browser helpers (localStorage may be blocked; then the choice lasts only this page).
export function currentDoor() {
  let stored = null;
  try { stored = localStorage.getItem(DOOR_KEY); } catch { /* private mode */ }
  return resolveDoor({ search: globalThis.location?.search ?? '', stored });
}
export function saveDoor(door) {
  try { localStorage.setItem(DOOR_KEY, door); } catch { /* private mode */ }
}
export function currentLook() {
  let stored = null;
  try { stored = localStorage.getItem(LOOK_KEY); } catch { /* private mode */ }
  return resolveLook({ search: globalThis.location?.search ?? '', stored });
}
export function saveLook(look) {
  try { localStorage.setItem(LOOK_KEY, look); } catch { /* private mode */ }
}
